import OrdersTable from "./OrdersTable";

export default function AllOrders() {
  return <OrdersTable type="all" />;
}
